import { getAtImageVariant } from './at-image.props'

export type AtImageVariant = 'none' | 'background' | 'banner-logo' | 'cover'

export interface AtImageProps {
  src?: string
  title?: string
  alt?: string
  variant?: AtImageVariant
  srcset?: string
  sizes?: string
  width?: number
  height?: number
}

export const AtImage = ({ src, title, alt, variant = 'none', srcset, sizes, width, height }: AtImageProps) => {
  return (
    <img
      className={getAtImageVariant(variant)}
      src={src}
      title={title}
      alt={alt}
      srcSet={srcset}
      sizes={sizes}
      width={width}
      height={height}
    />
  )
}
